import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Paper, Typography, Grid, Stack, IconButton } from "@mui/material";
import IconBox from "./component/IconBox";
import { getLessonPlanForOneDay } from "./services/lessonplan";
import parse from "html-react-parser";
import CustomCardWithBorder from "../../../components/CustomCardWithBorder";
import { Icon } from "@iconify/react";
import GlobalCard from "../../../components/GlobalCardComponent";
import LoaderCard from './../../../components/loaders/LoaderCard';
import Loader from "../../../../SAPPages/components/Loader/Loader";

export default function LessonDayDetails() {
  const { planId, dayNumber } = useParams();

  const [currentDay, setCurrentDay] = useState(null);

  const userId = localStorage.getItem("userId");
  const [loding , setLoding] = useState(false)

  useEffect(() => {
    fetchDay();
  }, []);

  const fetchDay = async () => {
    const payload = {
      sp_user_id: Number(userId),
      plan_id: planId,
      day_number: dayNumber,
    };
setLoding(true)
    try {
      const res = await getLessonPlanForOneDay(payload);
      setCurrentDay(res?.data || null);
      setLoding(false)
    } catch (err) {
      console.log(err);
      setLoding(false)
    }
  };

  return (
   
      <GlobalCard
          
        
        >
            {loding ? <Loader height="60vh" text="Fetching Data" /> :( 
            <>
            <Typography fontWeight={600}
            mb={3}
            sx={{ color: "#572575", fontSize: "22px", fontFamily: "Inter",  }}>Day {dayNumber} Lesson Plan</Typography>
        
         
          {/* Title */}
          <Typography
            fontWeight={600}
            mb={3}
            sx={{ color: "#9D0385", fontSize: "18px", fontFamily: "Inter" }}
          >
            {currentDay?.topic || "-"}
          </Typography>

       

          <Grid container spacing={3}>
            {/* Objective */}
            <Grid item xs={12}>
              <Stack direction="row" spacing={1.5}>
                <IconBox
                  icon="streamline:target-solid"
                  size={24}
                  iconSize={18}
                />

                <Box>
                  <Typography
                    sx={{
                      color: "#222222",
                      fontSize: "18px",
                      fontFamily: "Inter",
                      fontWeight: 600,
                    }}
                  >
                    Objective
                  </Typography>
                  <Typography
                    sx={{
                      color: "#444444",
                      fontSize: "16px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                    }}
                    mt={1}
                  >
                    {currentDay?.objective || "-"}
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            {/* Content */}
            <Grid item xs={12}>
              <Stack direction="row" spacing={1.5}>
                <IconBox icon="famicons:book-sharp" size={24} iconSize={18} />
                <Box>
                    <Typography
                    sx={{
                      color: "#222222",
                      fontSize: "18px",
                      fontFamily: "Inter",
                      fontWeight: 600,
                    }}
                  >
                    Content
                  </Typography>
                 <Typography
  sx={{
    color: "#444444",
    fontSize: "16px",
    fontFamily: "Inter",
    fontWeight: 400,

    // Enable bullets
    "& ul": {
      listStyleType: "disc",
      paddingLeft: "20px",
      margin: 0,
    },
    "& ol": {
      listStyleType: "decimal",
      paddingLeft: "20px",
      margin: 0,
    },
    "& li": {
      marginBottom: "4px",
    },
  }}
  mt={1}
>
  {parse(currentDay?.content || "-")}
</Typography>

                 
                </Box>
              </Stack>
            </Grid>

            {/* Activities */}
            <Grid item xs={12}>
              <Stack direction="row" spacing={1.5}>
                <IconBox icon="solar:graph-bold" size={24} iconSize={18} />

                <Box>
                  <Typography
                    sx={{
                      color: "#222222",
                      fontSize: "18px",
                      fontFamily: "Inter",
                      fontWeight: 600,
                    }}
                  >
                    Activities
                  </Typography>
                  <Typography
                    sx={{
                      color: "#444444",
                      fontSize: "16px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                    }}
                    mt={1}
                  >
                    {currentDay?.activity || "-"}
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            {/* Homework */}
            {/* <Grid item xs={12} md={6}>
              <Stack direction="row" spacing={1.5}>
                <IconBox icon="icon-park-solid:notes" size={24} iconSize={18} />

                <Box>
                  <Typography
                    sx={{
                      color: "#222222",
                      fontSize: "16px",
                      fontFamily: "Inter",
                      fontWeight: 600,
                    }}
                  >
                    Homework
                  </Typography>
                  <Typography
                    sx={{
                      color: "#444444",
                      fontSize: "12px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                    }}
                    mt={1}
                  >
                    Prepare 3 cue card responses
                  </Typography>
                </Box>
              </Stack>
            </Grid> */}

            {/* Notes */}
            <Grid item xs={12}>
              <Stack direction="row" spacing={1.5}>
                <IconBox
                  icon="material-symbols:add-notes-rounded"
                  width="24"
                  height="24"
                />

                <Box>
                  <Typography
                    sx={{
                      color: "#222222",
                      fontSize: "18px",
                      fontFamily: "Inter",
                      fontWeight: 600,
                    }}
                  >
                    Notes
                  </Typography>
                  <Typography
                    sx={{
                      color: "#444444",
                      fontSize: "16px",
                      fontFamily: "Inter",
                      fontWeight: 400,
                    }}
                    mt={1}
                  >
                    {currentDay?.remarks || "-"}{" "}
                  </Typography>
                </Box>
              </Stack>
            </Grid>

            {/* Attachments */}

            {currentDay?.presentation_file_obj?.length > 0 &&
            <Grid item xs={12}>
              <Grid container spacing={1}>
            <Grid item xs={12}>
             <Typography
                    sx={{
                      color: "#222222",
                      fontSize: "18px",
                      fontFamily: "Inter",
                      fontWeight: 600,
                    }}
                  >
                    Presentation
                  </Typography>
                  </Grid>
              {currentDay?.presentation_file_obj?.map((item) => (
                <Grid item xs={12}>
                     
                  <CustomCardWithBorder  padding="20px">
                    {/* Left Section */}
                    <Box
                      display="flex"
                      alignItems="center"
                      flexDirection="row"
                      justifyContent="space-between"
                      gap={2}
                    >
                      {/* File Icon */}
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Box
                          sx={{
                            width: 40,
                            height: 40,
                            bgcolor: "#FFECEC",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon
                            icon="mdi:file-document-outline"
                            color="#E53935"
                            width={26}
                          />
                        </Box>

                        {/* File Name */}
                        <Typography
                          sx={{
                            color: "#222222",
                            fontSize: "16px",
                            fontFamily: "Inter",
                            fontWeight: 600,
                          }}
                        >
                          {item?.original_filename || "-"}
                        </Typography>
                      </Box>

                      {/* Right Section */}
                      <Box display="flex" gap={1.5}>
                  
                      
                        {/* Download */}
                        <IconButton
                          onClick={() => {
                            window.open(item?.secure_url, "_blank");
                          }}
                          sx={{
                            bgcolor: "#F3E5F5",
                            "&:hover": { bgcolor: "#E1BEE7" },
                          }}
                        >
                          <Icon
                            icon="mdi:download"
                            color="#572575"
                            width={20}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  </CustomCardWithBorder>
                </Grid>
               
              ))}
              </Grid></Grid>}

            {currentDay?.study_material_obj?.length > 0 &&
            <Grid item xs={12}>
              <Grid container spacing={1}>
            <Grid item xs={12}>
             <Typography
                    sx={{
                      color: "#222222",
                      fontSize: "18px",
                      fontFamily: "Inter",
                      fontWeight: 600,
                    }}
                  >
                    Study Material
                  </Typography>
                  </Grid>
              {currentDay?.study_material_obj?.map((item) => (
                <Grid item xs={12}>
                     
                  <CustomCardWithBorder  padding="20px">
                    {/* Left Section */}
                    <Box
                      display="flex"
                      alignItems="center"
                      flexDirection="row"
                      justifyContent="space-between"
                      gap={2}
                    >
                      {/* File Icon */}
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Box
                          sx={{
                            width: 40,
                            height: 40,
                            bgcolor: "#FFECEC",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Icon
                            icon="mdi:file-document-outline"
                            color="#E53935"
                            width={26}
                          />
                        </Box>

                        {/* File Name */}
                        <Typography
                          sx={{
                            color: "#222222",
                            fontSize: "16px",
                            fontFamily: "Inter",
                            fontWeight: 600,
                          }}
                        >
                          {item?.original_filename || "-"}
                        </Typography>
                      </Box>

                      {/* Right Section */}
                      <Box display="flex" gap={1.5}>
                        {/* View */}
                        {/* <IconButton
                        onClick={() => {
                          window.open(
                            item?.file_path,
                            "_blank",
                          );
                        }}
                        sx={{
                          bgcolor: "#E3F2FD",
                          "&:hover": { bgcolor: "#BBDEFB" },
                        }}
                      >
                        <Icon icon="mdi:eye" color="#1976D2" width={20} />
                      </IconButton> */}

                        {/* Download */}
                        <IconButton
                          onClick={() => {
                            window.open(item?.secure_url, "_blank");
                          }}
                          sx={{
                            bgcolor: "#F3E5F5",
                            "&:hover": { bgcolor: "#E1BEE7" },
                          }}
                        >
                          <Icon
                            icon="mdi:download"
                            color="#572575"
                            width={20}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  </CustomCardWithBorder>
                </Grid>
               
              ))}
              </Grid></Grid>}
          </Grid>
          </>
          )}
        </GlobalCard>
   
  );
}
